import { CommonService } from '../../../shared/utils/common.service';
import { UtilsService } from '../../../shared/utils/utils.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { moduloPromociones } from '../diccionarios/PromocionesModulo.js';
import { DuplicatePromoDTO, Promocion } from '../modelos/Promocion';
import { ApiResponse } from 'src/app/model/interfaces/response';

@Injectable({
  providedIn: 'root'
})
export class PromocionesService {

  private url: string;
  private urlMaestros: string;
  private diccionarioModulo: any;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloPromociones;
    this.url = this._util.geturlVdi();
    //this.url = "http://localhost:8080/vdi/v1/api/services";
    this.urlMaestros = this._util.getDatosMaestros();
  }

  getAll(actives: boolean): Observable<Promocion[]> {
    return this._commom.peticionGetConHeader(
      `${this.url}${this.diccionarioModulo.url.promociones.obtenerTodo}?actives=${actives}`
    );
  }

  buscarPromo(id_promo: string): Observable<Promocion> {
    return this._commom.peticionGetConHeader(
      `${this.url}/promocion/${id_promo.toUpperCase()}`
    );
  }

  crearPromo(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.promociones.crear, payload);
  }

  borrar(id_promo: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.promociones.eliminar + id_promo
    );
  }

  sendVdi(id_promo: string) {
    return this._commom.peticionPostConHeader(
      `${this.url}/promocion/sendPromo/${id_promo}`, null
    );
  }

  duplicatePromo(body: DuplicatePromoDTO) {
    return this._commom.peticionPostConHeader(`${this.url}/promocion/duplicar`, body);
  }

  sendAll() {
    return this._commom.peticionPostConHeader(
      `${this.url}/promocion/sendPromo/all`, null, false
    );
  }

  downloadCsv(actives: boolean = false, rangeStart = '', rangeEnd = ''): Observable<string> {
    return this._commom.peticionGetConHeader(
      `${this.url}${this.diccionarioModulo.url.promociones.obtenerTodo}/csv?activas=${actives}&rangoInicio=${rangeStart}&rangoFin=${rangeEnd}`
    );
  }

  downloadCsvFromList(promos: string[]): Observable<string> {
    return this._commom.peticionPostConHeader(
      `${this.url}${this.diccionarioModulo.url.promociones.obtenerTodo}/csv`, promos
    );
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // BONIFICADOR
  ////////////////////////////////////////////////////////////////////////////////////////////////
  crearBonificador(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.bonificador.crear, payload);
  }

  cargarBonificador(payload: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.bonificador.obtenerPorIdPromo + payload
      // this.url + this.diccionarioModulo.url.bonificador.obtener
    );
  }

  borrarBonificador(payload: any): Observable<any> {
    console.log("payload", payload);
    return this._commom.peticionDeleteConHeader(

      this.url + this.diccionarioModulo.url.bonificador.borrar + "?idGrupo=" + payload.id_grupo + "&idMaterial=" + payload.id_material + "&idPromo=" + payload.id_promo + "&idUnidad=" + payload.id_unidad
    );
  }

  bonificadorCsv(promo: string, body: FormData) {
    return this._commom.peticionPostConHeader(`${this.url}${this.diccionarioModulo.url.bonificador.crear}/${promo}/csv`, body, false);
  }

  bonificadorDeleteAll(promo: string) {
    return this._commom.peticionDeleteConHeader(`${this.url}${this.diccionarioModulo.url.bonificador.borrar}/${promo}`)
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // BONIFICADOR REGALO
  ////////////////////////////////////////////////////////////////////////////////////////////////
  crearBonificadorRegalo(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.bonificadorRegalo.crear, payload);
  }

  cargarBonificadorRegalo(payload: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.bonificadorRegalo.obtenerPorIdPromo + payload
      // this.url + this.diccionarioModulo.url.bonificadorRegalo.obtener
    );
  }

  borrarBonificadorRegalo(payload: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.bonificadorRegalo.borrar + "?idGrupo=" + payload.id_grupo + "&idMaterial=" + payload.id_material + "&idPromo=" + payload.id_promo + "&idUnidad=" + payload.id_unidad + "&relacion21=" + payload.relacion21
    );
  }

  regaloCsv(promo: string, body: FormData): Observable<ApiResponse<string>> {
    return this._commom.peticionPostConHeader(`${this.url}${this.diccionarioModulo.url.bonificadorRegalo.crear}/${promo}/csv`, body, false);
  }

  regaloDeleteAll(promo: string) {
    return this._commom.peticionDeleteConHeader(`${this.url}${this.diccionarioModulo.url.bonificadorRegalo.borrar}/${promo}`)
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // GRUPO
  ////////////////////////////////////////////////////////////////////////////////////////////////
  crearGrupo(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.grupo.crear, payload);
  }

  cargarGrupo(payload: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.grupo.obtenerPorIdPromo + payload
      // this.url + this.diccionarioModulo.url.grupo.obtener
    );
  }

  borrarGrupo(payload: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.grupo.borrar + "?idGrupo=" + payload.id_grupo + "&idPromo=" + payload.id_promo
    );
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // COND. SUBMARCA
  ////////////////////////////////////////////////////////////////////////////////////////////////
  crearCondSubmarca(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.condSubmarca.crear, payload);
  }

  crearCondSubmarcaLista(payload: any[]): Observable<any> {
    return this._commom.peticionPostConHeader(
      `${this.url}${this.diccionarioModulo.url.condSubmarca.crear}/lista`, payload);
  }

  cargarCondSubmarca(payload: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.condSubmarca.obtenerPorIdPromo + payload
      // this.url + this.diccionarioModulo.url.condSubmarca.obtener
    );
  }

  borrarCondSubmarca(payload: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.condSubmarca.borrar + "?idSubmarca=" + payload.id_submarca + "&idPromo=" + payload.id_promo
    );
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // COND. GRUPO CLIENTE
  ////////////////////////////////////////////////////////////////////////////////////////////////
  crearCondGrupoCliente(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.condGrupoCliente.crear, payload);
  }

  cargarCondGrupoCliente(payload: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.condGrupoCliente.obtenerPorIdPromo + payload
      // this.url + this.diccionarioModulo.url.condGrupoCliente.obtener
    );
  }

  borrarCondGrupoCliente(payload: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.condGrupoCliente.borrar + "?idGrupoCliente=" + payload.id_grupo_cliente + "&idPromo=" + payload.id_promo
    );
  }

  condGrupoClienteDeleteAll(promo: string) {
    return this._commom.peticionDeleteConHeader(`${this.url}${this.diccionarioModulo.url.condGrupoCliente.borrar}/${promo}`)
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // COND. CLIENTE
  ////////////////////////////////////////////////////////////////////////////////////////////////
  crearCondCliente(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.condCliente.crear, payload);
  }

  editarCondCliente(payload: any): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.condCliente.crear, payload);
  }

  cargarCondCliente(payload: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.condCliente.obtenerPorIdPromo + payload
      // this.url + this.diccionarioModulo.url.condCliente.obtener
    );
  }

  borrarCondCliente(payload: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.condCliente.borrar + "?idCliente=" + payload.id_cliente + "&idPromo=" + payload.id_promo
    );
  }
  downloadCsvClient(promo: string): Observable<string> {
    return this._commom.peticionGetConHeader(
      `${this.url}${this.diccionarioModulo.url.condCliente.crear}/${promo}/csv`
    );
  }
  uploadCsvClient(body: FormData): Observable<ApiResponse<string>> {
    return this._commom.peticionPostConHeader(`${this.url}/cond-cliente/csv`, body, false);
  }

  condClienteDeleteAll(promo: string) {
    return this._commom.peticionDeleteConHeader(`${this.url}${this.diccionarioModulo.url.condCliente.borrar}/${promo}`)
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // COND. OFICINA VENTA
  ////////////////////////////////////////////////////////////////////////////////////////////////
  crearCondOficinaVenta(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.condOficinaVenta.crear, payload);
  }

  cargarCondOficinaVenta(payload: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.condOficinaVenta.obtenerPorIdPromo + payload
      // this.url + this.diccionarioModulo.url.condOficinaVenta.obtener
    );
  }

  borrarCondOficinaVenta(payload: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.condOficinaVenta.borrar + "?idOficinaVenta=" + payload.id_oficina_venta + "&idPromo=" + payload.id_promo
    );
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // COND. VENDEDOR
  ////////////////////////////////////////////////////////////////////////////////////////////////
  crearCondVendedor(payload: any): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.condVendedor.crear, payload);
  }

  crearCondVendedorLista(payload: any[]): Observable<any> {
    return this._commom.peticionPostConHeader(
      `${this.url}${this.diccionarioModulo.url.condVendedor.crear}/lista`, payload);
  }

  cargarCondVendedor(payload: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.condVendedor.obtenerPorIdPromo + payload
      // this.url + this.diccionarioModulo.url.condVendedor.obtener
    );
  }

  borrarCondVendedor(payload: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.condVendedor.borrar + "?idVendedor=" + payload.id_vendedor + "&idPromo=" + payload.id_promo
    );
  }

  ///////////////////////////////////////////////////////////////////////////////////////
  // CONSULTAS
  ///////////////////////////////////////////////////////////////////////////////////////
  tiposDePromociones(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.promociones.tipos
    );
  }

  oficinaVenta(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.oficinaVenta.ontenerTodos
    );
  }

  grupoCliente(): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.grupoCliente.ontenerTodos
    );
  }

  getCliente(idCliente: string) {
    return this._commom.peticionGetConHeader(this.urlMaestros + this.diccionarioModulo.url.cliente.obtenerPorId + idCliente);
  }

  getSubmarcas() {
    return this._commom.peticionGetConHeader(`${this.urlMaestros}/submarca`);
  }

  ///////////////////////////////////////////////////////////////////////////////////////
  // VALIDACIONES
  ///////////////////////////////////////////////////////////////////////////////////////
  validarOficinaVenta(oficinaVenta): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.oficinaVenta.validar + oficinaVenta
    );
  }

  validarVededor(idVendedor): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.vendedor.validar + idVendedor
    );
  }

  validarSubmarca(idSubmarca): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.submarca.validar + idSubmarca
    );
  }

  validarGrupo(idPromo, idGrupo): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.grupo.validar + "?idGrupo=" + idGrupo + "&idPromo=" + idPromo
    );
  }


  uploadCsv(promo: string, body: FormData, path: string): Observable<ApiResponse<string>> {
    return this._commom.peticionPostConHeader(`${this.url}/${path}/${promo}/csv`, body, false);
  }

//////////////////////////////// CONDICION POR TIER ////////////////////////////////

getListTier(): Observable<any> {
  return this._commom.peticionGetConHeader(
    this.urlMaestros + this.diccionarioModulo.url.oficinaVenta.ontenerTodos // PENDIENTES ENDPOINT DE TIER
  );
}

addCondicionPorTier(payload: any[]): Observable<any> {
  return this._commom.peticionPostConHeader(
    this.url + this.diccionarioModulo.url.condicionTier.crear, payload);
}

getAllCondicionPorTier(payload: any): Observable<any> {
  return this._commom.peticionGetConHeader(
    this.url + this.diccionarioModulo.url.condicionTier.getAll + payload
  );
}

borrarCondicionPorTier(payload: any): Observable<any> {
  return this._commom.peticionDeleteConHeader(
    this.url + this.diccionarioModulo.url.condicionTier.delete + payload.id_tiers + "&idPromo=" + payload.id_promo
  );
}

// T.20331 Essential:  nuevas condiciones de promoción
//////////////////////////////// CONDICION POR AGRUPACION TARIFA - SUBCANAL ////////////////////////////////

getAllCondAgrupacionTarifa(payload: any): Observable<any> {
  return this._commom.peticionGetConHeader(
    this.url + this.diccionarioModulo.url.condAgrupacionTarifa.getAll + payload);
}

addCondAgrupacionTarifa(payload: any): Observable<any>{
  return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.condAgrupacionTarifa.crear, payload);
}

borrarCondAgrupacionTarifa(payload: any): Observable<any> {
  return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.condAgrupacionTarifa.delete, payload);
}

//////////////////////////////// CONDICION POR CANAL VENDEDOR -- CANAL CLIENTE ////////////////////////////////

getAllCondCanalVendedor(payload: any): Observable<any> {
  return this._commom.peticionGetConHeader(
    this.url + this.diccionarioModulo.url.condCanalVendedor.getAll + payload);
}

addCondCanalVendedor(payload: any[]): Observable<any> {
  return this._commom.peticionPostConHeader(
    this.url + this.diccionarioModulo.url.condCanalVendedor.crear, payload);
}

borrarCondCanalVendedor(payload: any): Observable<any> {
  return this._commom.peticionDeleteConHeader(
    this.url + this.diccionarioModulo.url.condCanalVendedor.delete, payload);
}
// T.20331

//////////////////////////////// CONDICION VARIANTE (COMBOS) ////////////////////////////////
crearVariante(payload: any): Observable<any> {
  return this._commom.peticionPostConHeader(
    this.url + this.diccionarioModulo.url.condVariante.crear, payload);
}

getVariantesPorPromo(idPromo: string): Observable<any> {
  return this._commom.peticionGetConHeader(
    this.url + this.diccionarioModulo.url.condVariante.obtenerPorIdPromo + idPromo);
}

getVariantesPorMaterial(idPromo: string, idMaterial: string, idUnidad: string): Observable<any> {
  return this._commom.peticionGetConHeader(
    `${this.url}${this.diccionarioModulo.url.condVariante.obtenerPorMaterial}?idPromo=${idPromo}&idMaterial=${idMaterial}&idUnidad=${idUnidad}`
  ).pipe(
    catchError(() => of([]))
  );
}

getVarianteById(idPromo: string, idMaterial: string, idUnidad: string, idMaterialVar: string): Observable<any> {
  return this._commom.peticionGetConHeader(
    `${this.url}${this.diccionarioModulo.url.condVariante.obtenerPorId}?idPromo=${idPromo}&idMaterial=${idMaterial}&idUnidad=${idUnidad}&idMaterialVar=${idMaterialVar}`);
}

eliminarVariante(idPromo: string, idMaterial: string, idUnidad: string, idMaterialVar: string): Observable<any> {
  return this._commom.peticionDeleteConHeader(
    `${this.url}${this.diccionarioModulo.url.condVariante.borrar}?idPromo=${idPromo}&idMaterial=${idMaterial}&idUnidad=${idUnidad}&idMaterialVar=${idMaterialVar}`);
}

eliminarVariantesPorPromo(idPromo: string): Observable<any> {
  return this._commom.peticionDeleteConHeader(
    `${this.url}${this.diccionarioModulo.url.condVariante.borrarPorPromo}${idPromo}`);
}

}
